// 违章安全教育考试
import React from 'react';
import {Prompt} from 'react-router-dom';
import { href } from '../utils/util';
import correct from './images/correct.png';
import { Button, Modal, Toast } from 'antd-mobile';

import { post } from '../utils/request';
import api from './api';

import './index.less';

let LETTER = ['A','B','C','D','E','F','G','H','I','J','K'];
let UPPER = ['零','一','二','三','四','五','六','七','八','九','十'];
class SafetyTrainingExamList extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            page:'question',
            urlOps: {},
            answer: {
                link:-1,
            }, //选中的答案
            examList: [], //所有题目 { questionType:试卷内容类型,1:文字类;2:图片类, branchContext:选项内容[{"branchName":"选项11111","isAnswer":"1"}]	}
            next: 1,
            maxtime:  30 * 60,//30分钟
            minutes: 30,//分钟
            seconds: 0,//秒
            visible:false,
            exitvisible:false,
            result:{},//考试结果
        };
    }
    componentDidMount(){
        localStorage.setItem('isPrompt',true)//离开

        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                Toast.fail('您还未登录，请登录后再操作',999);
                return;
            }
            this.setState({
                urlOps: ops,
                next:1,
                maxtime: ops.duration, //秒
                minutes: Math.floor(ops.duration / 60), //分
                seconds: Math.floor(ops.duration % 60), //秒
            },()=>{
                this.createExamPaperQuestion();
            });
        }
    }
    componentWillUnmount(){
        this.timer && clearInterval(this.timer);
    }

    createExamPaperQuestion=()=>{
        let { urlOps } = this.state;
        post({
            url: api.createExamPaperQuestion + '?app_stoken=' + urlOps.app_stoken + '&activity=365', 
            data: {
                questionBankCode: urlOps.bankCode,
                totalScore: urlOps.score,
                totalNum: urlOps.num,
            }
        }).then((res) => {
            if(res.result == 'success'){
                
                //倒计时
                this.timer && clearInterval(this.timer);
                this.timer = setInterval(()=>{this.countDown();}, 1000);

                res.data.map((d,i)=>{
                    d.branchContext = JSON.parse(d.branchContext);
                });
                this.setState({
                    examList: res.data
                });
            }else{
                Toast.info(res.msg,1);
            }
        });

    }
    setNext(){
        let { urlOps, next, } = this.state;
        if(next != urlOps.num && next < urlOps.num){
            this.setState({
                answer:{
                    link:-1,
                },
                next: ++next
            })
        }else if(next == urlOps.num){
            this.commitExamResult();
        }
        
    }

    commitExamResult=()=>{
        localStorage.setItem('isPrompt',false)//离开

        let { examList, urlOps, minutes, seconds } = this.state;
        this.timer && clearInterval(this.timer);

        post({
            url: api.commitExamResult + '?app_stoken=' + urlOps.app_stoken + '&activity=365', 
            headers: {
                'Content-Type': 'application/json',
            },
            data: {
                examPaperCode: urlOps.paperCode,
                activityCode:urlOps.actCode,
                activityUserPrizeCode: urlOps.prizeCode,
                duration: Number(urlOps.duration) - Number(minutes*60 + seconds),
                resultList: examList.map((d,i)=>{
                    return {
                        examPaperQuestionId: d.hoExamPaperQuestionId,
                        branchContext:d.branchContext,
                    }
                }),
            }
        }).then((res) => {
            //倒计时
            this.timer && clearInterval(this.timer);
            if(res.result == 'success'){
                this.setState({
                    result: res.data,
                    page:'result',
                });

            }else{
                Toast.info(res.msg,1);
            }

            
        });
    }

    countDown=()=>{
        let { maxtime, minutes, seconds, } = this.state;

        if (maxtime >= 0) {
            minutes = Math.floor(maxtime / 60);
            seconds = Math.floor(maxtime % 60);
            --maxtime;
            this.setState({
                maxtime, 
                minutes, 
                seconds
            });
        }else{
            this.timer && clearInterval(this.timer);
            this.setState({
                visible:true,
            });
        }
    }

    handleSelectedAnswer= (value, index)=>{
        var that = this;

        let { examList, next, answer, urlOps, }  = that.state;

        // 已选择
        if(answer.link != '-1'){
            return
        }

        examList[next-1].branchContext[index].result = '1';

        that.setState({
            examList:examList,
            answer: (value.isAnswer == '1' && next != urlOps.num && next < urlOps.num) ? {
                link:-1,
            }: {
                ...value,
                link: index,
            },
        },()=>{
            if(value.isAnswer == '1' && next != urlOps.num && next < urlOps.num){
                setTimeout(()=>{
                    that.setState({
                        next: ++next,
                    })
                },300);
            }
        })

        //选中正确答案
        // if(next != urlOps.num && next < urlOps.num){
        //     this.setState({
        //         answer:{
        //             link:-1,
        //         },
        //         next: ++next
        //     })
        // }else if(next == urlOps.num){
        //     // this.commitExamResult();
        // }
    }

    render() {
        const { 
            page,
            result,
            maxtime,
            examList, 
            urlOps, 
            next, 
            minutes, 
            seconds, 
            visible, 
            exitvisible, 
            answer } = this.state;
        return (
            <div>
                {
                        /* 考试 */
                    page == 'question' ? 
                    <div className="question">
                        <div className="top">
                            <div className='title'>
                                <div>答题进度  <span className="num">{next}</span>  <span>/{urlOps.num}</span></div>
                                <div className="text-right">剩余时间  <span className="num2">{minutes}分{seconds}秒</span></div>
                            </div>
                            <div className='line'>
                                <div className='lineNum' style={{'width': `${next/urlOps.num*100}`+ '%'}}></div>
                            </div>
                        </div>
                        {
                            examList.length ? 
                                <div className='content'>
                                    <div className='examName'>{next}、{examList[next-1].questionTitle}（{examList[next-1].score}分）</div>
                                    {
                                        examList[next-1].questionType == '1' ? 
                                        <div className='questionList'>{
                                            examList[next-1].branchContext.map((d,i)=>{
                                                return (
                                                    <div key={i} style={{'paddingRight':d.result == '1' ? '36px' : '36px'}} 
                                                    className={`questionItem 
                                                    ${d.result == '1' && d.isAnswer == '1' ? 'correct':'' }
                                                    ${answer.link!='-1'&& d.result != '1' && answer.link != i && d.isAnswer == '1' ? 'correct':'' }  
                                                    ${d.result == '1' && d.isAnswer == '0' ? 'error':'' }`} 
                                                    onClick={()=>{ this.handleSelectedAnswer(d,i) }}>{LETTER[i]}、{d.branchName}</div>
                                                )
                                            })
                                        }
                                        </div> :
                                        <div className='questionListImage'>
                                            <ul  className='questionItem'>
                                                {
                                                    examList[next-1].branchContext.map((d,i)=>{
                                                        return d.branchName ? (
                                                            <li className='questionItemWrap' key={i}>
                                                                <div className={`questionBox 
                                                                ${answer.link == i && d.isAnswer == '1' ? 'correct':''}
                                                                ${answer.link == i && d.isAnswer == '0' ? 'error':'' }`}
                                                                onClick={()=>{ this.handleSelectedAnswer(d,i) }}>
                                                                    <img src={d.branchName}></img>
                                                                </div>
                                                                {
                                                                    answer.link == i && d.isAnswer == '1' ? 
                                                                    <div className='icon correctIcon'>正确</div> : ''
                                                                }
                                                                {
                                                                    answer.link == i && d.isAnswer == '0' ? 
                                                                    <div className='icon errorIcon'>错误</div> : ''
                                                                }
                                                                {  answer.link != i ?
                                                                    <div className='icon'></div> : ''
                                                                }
                                                            </li>
                                                            ) : ''
                                                        }) 
                                                }
                                            </ul>

                                        </div>
                                    }
                                    
                                </div> : ''
                        }
                        
                        <div className='button green'>
                            {
                                answer.link != '-1' ? 
                                <Button type="primary" size='large' className='button' onClick={()=>{
                                    this.setNext()
                                    // localStorage.setItem('isPrompt',false)//离开
                                    // this.setState({
                                    //     result: {},
                                    //     page:'result',
                                    // });
                                }}>{ next == urlOps.num ? '提交试卷查看成绩': '下一题'}</Button> : ''
                            }
                            
                        </div>
                        <Modal
                            visible={visible}
                            transparent
                        >
                            <div className='modalContent'>
                                <div className='title'>很抱歉，考试时间已结束，请提交试卷！</div>
                            </div>
                            <div className='orange'>
                                <Button color='primary' fill='solid' onClick={()=>{
                                    this.commitExamResult();
                                }}>
                                    提交试卷查看成绩
                                </Button>
                            </div>
                        </Modal>
                        <Prompt
                            when={true}
                            message={(location) =>{
                                if(localStorage.getItem('isPrompt') == 'false'){
                                    return true
                                }else{
                                    // 停止计时
                                    this.timer && clearInterval(this.timer);
                                    this.setState({exitvisible:true});
                                    return false
                                }
                            }}
                        />
                        <Modal
                            visible={exitvisible}
                            transparent
                        >
                            <div className='modalContent'>
                                <div className='title'>确定退出做题</div>
                                <div className='tip'>您还有<span>{ Number(urlOps.num) - next}</span>道题未做</div>
                            </div>
                            <div className='orange'>
                                <Button color='primary' fill='solid' onClick={()=>{
                                    localStorage.setItem('isPrompt',true)//离开
                                    this.setState({
                                        exitvisible:false,
                                    });
                                    this.timer = setInterval(()=>{this.countDown();}, 1000);
                                }}>
                                    继续考试
                                </Button>
                            </div>
                            <div className='text-center' style={{'lineHeight':'48px'}} onClick={()=>{
                                localStorage.setItem('isPrompt',false)//离开
                                if(window.location.hash.indexOf('peaceSharkIndex') > -1){
                                    href(`/peaceSharkIndex?app_stoken=${urlOps.app_stoken}&time=${new Date().getTime()}`);
                                }else{
                                    href(`/peaceSharkIndex?app_stoken=${urlOps.app_stoken}`);
                                }
                            }}>坚持退出</div>
                        </Modal>
                    </div> : 

                    /* 结果 */
                    <div className="result">
                        <div className="top">
                            <div className="topBg"></div>
                        </div>
                        <div className='topBox'>
                                <div className='bg'></div>
                        </div>
                        <div className="box">
                            <div className="title">{decodeURI(urlOps.name)}</div>
                            <div className="content">
                                <div className='scores'>
                                    <div className='scoresTitle'>您的分数</div>
                                    <div className='scoresNum'><span>{result.score}</span>分</div>
                                    <div className='scoresAll'>
                                        <span>满分{urlOps.score}分</span>
                                    </div>
                                    {
                                        result.examResult == '1' ? 
                                            <div className='correct'>太棒了，成绩合格</div>: 
                                            <div className='error'>很遗憾，成绩为不合格</div>
                                    }
                                </div>
                                <div className='grid'>
                                    <div className='item-left'>考生姓名</div>
                                    <div className='item-right'>{result.customerName}</div>
                                </div>
                                <div className='grid'>
                                    <div className='item-left'>考试日期</div>
                                    <div className='item-right'>{result.gmtCreate}</div>
                                </div>
                                <div className='grid'>
                                    <div className='item-left'>考试用时</div>
                                    <div className='item-right'>{ Math.floor(result.duration / 60) }分{Math.floor(result.duration % 60)}秒</div>
                                </div>
                                <div className='grid'>
                                    <div className='item-left'>正确率</div>
                                    <div className='item-right'>{result.accuracy*100}%</div>
                                </div>
                                <div className='grid'>
                                    <div className='item-left'>考试得分</div>
                                    <div className='item-right'>{result.score}分</div>
                                </div>
                            </div>
                        </div>
                        {
                            result.examResult == '1' ? 
                            <div className='buttonBox orange'>
                                <Button color='primary' fill='solid' className='button' onClick={()=>{
                                    // let baseUrl = window.location.pathname;//'/';
                                    // window.location.replace(`${baseUrl}#/peaceSharkIndex?app_stoken=${urlOps.app_stoken}`);

                                    window.history.go(-2);
                                    setTimeout(()=>{
                                        href(`/peaceSharkIndex?app_stoken=${urlOps.app_stoken}`);
                                    },0);
                                }}>去摇一摇领现金</Button>
                                <div className='text'>恭喜您重新获得继续参与活动资格！</div>
                            </div> :
                            <div className='buttonBox green'>
                                <Button color='primary' fill='solid' className='button' onClick={()=>{
                                    window.history.go(-1);
                                    console.log('urlOps',urlOps);
                                    setTimeout(()=>{
                                        href(`/safetyTrainingExam?app_stoken=${urlOps.app_stoken}&questionBankCode=${urlOps.bankCode}&shakeCode=${urlOps.shakeCode}&activityCode=${urlOps.actCode}`);
                                    },0);
                                }}>再考一次</Button>
                                <div className='text' onClick={()=>{
                                    // let baseUrl = window.location.pathname;//'/';
                                    // window.location.replace(`${baseUrl}#/peaceSharkIndex?app_stoken=${urlOps.app_stoken}`);
                                    window.history.go(-2);
                                    setTimeout(()=>{
                                        href(`/peaceSharkIndex?app_stoken=${urlOps.app_stoken}`);
                                    },0);
                                }}>返回活动首页</div>
                            </div> 
                        }

                    </div>
                }
                
            </div>
            
        );
    }
}
export default SafetyTrainingExamList;



// WEBPACK FOOTER //
// ./src/safetyTrainingExam/exam.js